/**
 * Helper utilities for REACH List Versions filtering and validation.
 * Per EXG5-506 and EXG5-507 requirements.
 * 
 * Note: This is separate from ReachListVersions.ts which is auto-generated.
 */

import { ReachListVersions, ReachListVersion } from './ReachListVersions';

export class ReachListVersionsHelper {
    // Cutoff date for survey dropdowns per EXG5-506
    private static readonly SURVEY_CUTOFF_DATE = "2021-01-05";

    /**
     * Get filtered list for survey contexts (versions after Jan 5, 2021 only)
     */
    public static getFilteredForSurvey(): ReachListVersion[] {
        return ReachListVersions.reachListVersions.filter(v => v.date >= ReachListVersionsHelper.SURVEY_CUTOFF_DATE);
    }

    /**
     * Get the most recent REACH list version
     */
    public static getMostRecent(): ReachListVersion {
        return ReachListVersions.reachListVersions[0];
    }

    /**
     * Check if a given date is the most recent version
     */
    public static isMostRecent(date: string): boolean {
        return date === this.getMostRecent().date;
    }
}